import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ViewProps } from 'react-native';

import { useNavigation } from '@react-navigation/native';

import { HomeIconFull } from '@/assets/icons/homeIconFull';
import { lobbyId, useLobbySectionSelection } from '@/feature/lobby/hooks/use-lobby-section-selection';
import { PickemLobbyTabNavigationProp } from '@/navigation/pickem/types';

import { LaunchpadTile } from './LaunchpadTile';

/**
 * A tile component that provides navigation to the main lobby screen
 * @param onLayout - Layout event handler for the tile - function from the parent LeftSideTabBar
 * @param updateTab - Callback function to update the currently active tab in parent navigation
 */
export const PickemLobbyLaunchpadTile = memo(
    ({ onLayout, updateTab }: { onLayout: ViewProps['onLayout']; updateTab: () => void }) => {
        const setSelectedTile = useLobbySectionSelection(state => state.actions.setSelectedTile);
        const navigation = useNavigation<PickemLobbyTabNavigationProp>();

        const isSelected = useLobbySectionSelection(state => state.selectedTile === lobbyId);
        const { t } = useTranslation('common');

        const onPressLobby = useCallback(() => {
            updateTab();
            navigation.setParams({
                league: lobbyId,
            });
            setSelectedTile(lobbyId);
        }, [navigation, updateTab, setSelectedTile]);

        return (
            <LaunchpadTile
                testID={'pickem-lobby-launchpad-tile'}
                onLayout={onLayout}
                icon={<HomeIconFull />}
                label={t('lobby')}
                onPress={onPressLobby}
                selected={isSelected}
                paddingTop={'s14'}
            />
        );
    }
);

PickemLobbyLaunchpadTile.displayName = 'PickemLobbyLaunchpadTile';
